export type SortType = "up" | "down";

export type SortState = {
  prop: string;
  type: SortType;
};

export const DEFAULT_SORT_STATE: SortState = {
  prop: "dataAtend",
  type: "down",
};

const defaultSortTypeByColumn: Record<string, SortType> = {
  dataAtend: "down",
};

const getDefaultSortType = (prop: string): SortType => {
  return defaultSortTypeByColumn[prop] ?? "up";
};

export const getColumnSortType = (prop: string, sortState: SortState): SortType => {
  if (sortState.prop === prop) {
    return sortState.type;
  }

  return getDefaultSortType(prop);
};

export const getNextSortState = (prop: string, sortState: SortState): SortState => {
  if (sortState.prop === prop) {
    return {
      prop,
      type: sortState.type === "up" ? "down" : "up",
    };
  }

  return {
    prop,
    type: getDefaultSortType(prop),
  };
};
